import { app } from '../../bootstrap/core';
import { ticketState, ticketStateName } from './ticket.state';
import { ticketComponent } from './ticket.component';
import { TicketService } from './ticket.service';
import { TicketFlowService } from './ticketFlow.service';

import {
  TicketActions,
  TicketStates,
  TicketStatesReceiving,
  TicketStatesTransferring,
  TicketStatesSiblings,
  TicketTypeMatching,
  TicketType,
  TicketRequestType,
  TicketRequestTypeMap,
  ViewStatus,
  ExternalLinking,
} from './ticket.constants';

import {
  TicketRoutesTransferring,
  TicketRoutesReceiving,
  TicketRoutesReceivingDirect,
  TicketRoutesReceivingLight,
  TicketRoutesCustomer,
  TicketRoutesFrontOffice,
  TicketRoutesTransferringFrontOffice,
  TicketRoutesDataCapturingProvider,
  TicketRoutesFrontOfficeWithStandingOrders,
  TicketRoutesDWS,
} from './ticket.routes';

// TODO move this to a global ticket constants file
import { ReceivingKwhTypes } from '../tickets/create/receiving/receiving.constants';
import { ticketHotkeyGoNext } from './ticket.hotkey';
import { ibanToggleFilter } from './ticket.filter';

import '../../common/ui/progress/progress';
import '../../common/ui/download/download';
import '../../common/ui/ticket/ticketStatus/ticketStatus';
import '../../common/ui/ticket/ticketSummary/ticketSummary';
import '../../common/ui/ticket/ticketNotes/ticketNotes';
import '../../common/ui/userSummary/userSummary';
import '../../common/ui/documentSummary/documentSummary';
import '../../common/ui/history/history';
import '../../common/ui/sidebar/sidebar';
import '../../common/ui/addressFormular/addressFormular';
import '../../common/ui/confirmFinances/confirmFinances';
import '../../common/ui/confirmAuthorization/confirmAuthorization';
import ticketSidebarPartial from './partials/ticket.sidebar.tpl.html';
import ticketClosePartial from './partials/ticket.close.tpl.html';
import ticketIbanArrowsPartial from './partials/ticket.ibanArrows.tpl.html';
import ticketStatusCustomPartial from './partials/ticket.statusCustom.tpl.html';
import ticketStatusCompletedPartial from './partials/ticket.statusCompleted.tpl.html';
import ticketStatusPendingPartial from './partials/ticket.statusPending.tpl.html';
import ticketStatusLockedPartial from './partials/ticket.statusLocked.tpl.html';
import ticketDetailPartial from './partials/ticket.detail.tpl.html';

app.config(ticketState);
app.constant('TicketActions', TicketActions);
app.constant('TicketRoutesReceiving', TicketRoutesReceiving);
app.constant('TicketRoutesReceivingDirect', TicketRoutesReceivingDirect);
app.constant('TicketRoutesReceivingLight', TicketRoutesReceivingLight);
app.constant('TicketRoutesTransferring', TicketRoutesTransferring);
app.constant('TicketRoutesCustomer', TicketRoutesCustomer);
app.constant('TicketRoutesFrontOffice', TicketRoutesFrontOffice);
app.constant('TicketRoutesDWS', TicketRoutesDWS);
app.constant(
  'TicketRoutesFrontOfficeWithStandingOrders',
  TicketRoutesFrontOfficeWithStandingOrders,
);
app.constant(
  'TicketRoutesTransferringFrontOffice',
  TicketRoutesTransferringFrontOffice,
);
app.constant(
  'TicketRoutesDataCapturingProvider',
  TicketRoutesDataCapturingProvider,
);
app.constant('TicketStates', TicketStates);
app.constant('TicketStatesReceiving', TicketStatesReceiving);
app.constant('TicketStatesTransferring', TicketStatesTransferring);
app.constant('TicketStatesSiblings', TicketStatesSiblings);
app.constant('TicketTypeMatching', TicketTypeMatching);
app.constant('TicketType', TicketType);
app.constant('TicketRequestType', TicketRequestType);
app.constant('TicketRequestTypeMap', TicketRequestTypeMap);
app.constant('ViewStatus', ViewStatus);
app.constant('ExternalLinking', ExternalLinking);
app.constant('ticketStateName', ticketStateName);
app.value('ReceivingKwhTypes', ReceivingKwhTypes);
app.value('ticketSidebarPartial', ticketSidebarPartial);
app.value('ticketClosePartial', ticketClosePartial);
app.value('ticketIbanArrowsPartial', ticketIbanArrowsPartial);
app.value('ticketStatusCustomPartial', ticketStatusCustomPartial);
app.value('ticketStatusCompletedPartial', ticketStatusCompletedPartial);
app.value('ticketStatusPendingPartial', ticketStatusPendingPartial);
app.value('ticketStatusLockedPartial', ticketStatusLockedPartial);
app.value('ticketDetailPartial', ticketDetailPartial);
app.service('ticketService', TicketService);
app.service('ticketFlowService', TicketFlowService);
app.filter('ibanToggle', ibanToggleFilter);
app.component(ticketComponent.name, ticketComponent);
app.run(ticketHotkeyGoNext);
